// extracted by mini-css-extract-plugin
module.exports = {"title":"DoubleOptInSuccessFeedback_title__UbrDX","body":"DoubleOptInSuccessFeedback_body__4eSFI","button":"DoubleOptInSuccessFeedback_button__gW2x_"};